<!--
一、该组件有三种被调用的形式：
   1. 由 PopupEntity 组件所调用，通过 PopupEntity 传入 slots 数据；这种方式称之为 popup popupingEntity model
   2. 通过 url 直接访问该组件，通过路由直接跳转，这种方式是从 url 中获取 popupingEntity id，然后去数据库查找 slots。这种方式称之为 single popupingEntity page model
   3. 不过有种场景需要考虑到，就是在 Mobile 尺寸下的时候，从 list page 点击跳转到该页面（这个时候并不是通过 PopupEntity 即弹出窗口展示了），
      因为这是一次新的路由，因此 #1 的方式就不行了，不能通过 slots 传参了，这个是偶可以通过 router 的 params 传递传输过来，这样就可以减少
      一次数据库的查询！=> 考虑 #1 和 #2 统一起来。
二、rendering 标志位，该标志位的作用是，当异步数据准备就绪后，才开始渲染 popupingEntity 组件。-> TODO 是否将名字改为 rendering？
三、Entity 组件在大部分访问情况下都做到了秒开！大部分的访问访问情况都是 List -> Entity（只有直接从 URL 访问 Entity 除外），而这种情况一定产生
   cache hit。分析：当点击 List page 中的某个 Entity 用于展示的时候即调用 List.showEntity()，是直接从 List#entities 中获取该 Entity，
   然后将其 cache。然后通过路由变化进入 Entity 并调用 initEntity，该方法直接从 Cache中获得 Entity，因此整个过程不会产生任何的远程调用。
-->
<template>
    <div :class="{'margin-top-60px': isSinglePage && !isPhoneAgent, 'margin-top-50px': isPhoneAgent && isSinglePage}">
        <!-- 先禁用 mescroll-wrapper，将其注释掉但保留其实现，我怀疑视频播放中，导致偶然情况下左右 sliding 失败是由它导致的，因为再添加它之前没有遇到过这样的问题，注释掉观察观察。
        <mescroll-wrapper :pull-down-callback-handler="pullDownCallbackHandler" prevent-ele-id="entity" v-if="rendering"> -->
        <download-app
            :class="{'download-app-pc-align': isSinglePage && !isPhoneAgent}"
            :app-name="getShareAppName()"
            :logo-path="getShareAppLogoPath()"
            :logo-width="getShareLogoWidth()"
            :version="getShareAppVersion()"
            :slogan="getShareSlogan()"
            :download-path="getShareDownloadPath()"

        />
        <div class="entity-wrapper"
             id="entity" v-if="rendering">
            <carousel :z-index="300"
                      :entity="entity"
                      v-bind="$attrs"
                      @infoboard-height="updateInfoboardHeight"
                      @infoboard-width="updateInfoboardWidth"
                      @spacing="handleSpacing" />
            <infoboard v-if="!isPhoneAgent" :e="entity" :height="infoboardHeight" :width="infoboardWidth" :class="{'box-shadow-grayline': isSinglePage}"/>
            <phone-infoboard v-else :e="entity"></phone-infoboard>
            <!-- below is for single popupingEntity page only -->
            <template v-if="isSinglePage">
                <el-divider style="max-width: 975px;">更多精彩尽在「{{getShareAppName()}}」app</el-divider>
                <no-signal
                    v-if='noSignalVisible'
                    ref="noSignal"
                    display-mode="vertical"
                    :retry-handlers="[reloadPage]"
                    :retry-basis="false"
                    :margin-top="0"></no-signal>
                <!-- @deprecated since v2.3.0 为了防止用户通过微信分享漏洞查看资源
                <el-divider style="max-width: 975px;">该博主的更多精彩推荐</el-divider>
                <list ref="list" :next-page-func="getRecommends" :scrollable="false"></list>
                -->
            </template>
        </div>
        <!-- </mescroll-wrapper> -->
    </div>
</template>

<script>
    import DownloadApp from "../commons/DownloadApp";
    import Carousel from './Carousel'
    import Infoboard from "./infoboard/Infoboard";
    import { getEntity, saveViewHis } from "../../data/entity";
    import { getSample } from "../../data/profile";
    import env from '../../../config/env';
    import {
        ShowEntityMode,
        isPhoneAgent,
        errorMessage,
        GlobalLoading,
        Styles,
        pushBaiduSeo,
        isHybridAgent
    } from "../../utils";
    import PhoneInfoboard from "./infoboard/PhoneInfoboard";
    import { TimeoutError, NetworkError } from '@shangyang/error';
    import MescrollWrapper from "../commons/MescrollWrapper";

    export default {
        name: "Entity",
        components: {
            DownloadApp,
            Carousel,
            Infoboard,
            PhoneInfoboard,
            MescrollWrapper,
            /**
             * 循环依赖的问题
             * https://forum.vuejs.org/t/recursive-component-returning-did-you-register-the-component-correctly/29625
             * https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
             */
            List: () => import("../list/List")   // 解决循环依赖
        },
        data() {
            return {
                // 下面记录为什么要将 popupingEntity 放入 cached visited entities 的分析过程
                // 可以考虑将 comments 纳入到 popupingEntity 中，这样可以显著减少页面的展示时间，
                // 1. 一则是可以考虑加载过评论了就不再加载评论了，
                // 2. 二则是想要每次切换 Entity 的时候都加载最新评论，可以替换 Entity.comments 进行响应式更新，好处是页面响应非常快！
                // 现在还是将 comments 纳入到 Entity 中，这样如果已经加载过的 comments 则不用再加载了。
                entity: null,
                infoboardHeight: 0,
                infoboardWidth: 335, // the default pc width,
                isSinglePage: false, // 是否直接是通过 /e/:id 的方式访问的，而不是通过 list page 跳入的,
                rendering: false, // 什么时候开始渲染 Entity page。一般而言，等待异步加载成功以后，才渲染该组件！
                noSignalVisible: false
            }
        },
        computed: {
            isPhoneAgent: function() {
                return isPhoneAgent()
            },

            // 从 query param 中解析出 appCode 参数
            appCode() {
                // 注意，默认值为 huocool
                let appCode = this.$route.query.appCode || "huocool";
                console.log(`the appCode has been resolved as ${appCode}`);
                return appCode;
            }
        },
        // 注意，一旦开启了 keep alived，before mount、created 等生命周期的方法都只会在第一次被调用。
        beforeMount() {
            console.log('Entity, before mount');
            var shortcode = this.$route.params.shortcode;
            this.initEntity(shortcode);
        },
        watch: {
            /**
             * 动态路由的解析方式，watch $route 有一个特性就是第一次初始化 Entity 组件的时候，即从其他组件 -> Entity 不会被触发，因此
             * 就不会和 beforeMount 方法相冲突了（不然都会去调用 initEntity 方法）。有关动态路由的详细介绍参考《Vue 动态路由.md》
             * 注意，当第一次 Entity 被初始化后，Entity -> 其他组件或者是其他组件 -> Entity，watch $route 都是会触发的，这是 beforeRouteUpdate
             * 所不具备的特性，beforeRouteUpdate 是严格按照只有参数变化才会触发的原则。
             */
            $route(to, from){
                console.log('Entity, the route get changed, to:', to.name, 'from:', from.name);
                if(from.name === 'entity'){
                    console.log('Entity, try destroy');
                    this.rendering = false; // 必须销毁，销毁的目的是让 Carousel 能够在其生命周期方法中重新计算图片的展示尺寸，否则会畸形。典型的用例 http://www.huocool.com.cn/e/SwDnagyJYSi
                }
                if(to.name === 'entity'){
                    console.log('Entity, try initialize');
                    this.initEntity();
                }
            }
        },
        methods: {

            getShareAppName() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    // return 'inSoul';
                    return "西音"
                else if (appCode === 'adjiang')
                    return '爱豆酱';
                else if (appCode === 'worldscene')
                    return '即拍'
                else if (appCode === 'xiyin')
                    return '西音'
                return "";
            },

            getShareAppLogoPath() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    // return '/static/app-logo_insoul.png';
                    return '/static/app-logo_xiyin.png';
                else if (appCode === 'adjiang')
                    return '/static/app-logo_adjiang.png';
                else if (appCode === 'worldscene')
                    return '/static/app-logo_worldscene.png';
                else if (appCode === 'xiyin')
                    return '/static/app-logo_xiyin.png';
                return "";
            },

            getShareLogoWidth() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    return 80;
                else if (appCode === 'adjiang')
                    return 64;
                else if (appCode === 'worldscene')
                    return 64;
                else if (appCode === 'xiyin')
                    return 64;
                return 80;
            },

            getShareAppVersion() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    return this.$store.state.latestVersion;
                else if (appCode === 'adjiang')
                    return null;
                else if (appCode === 'worldscene')
                    return null;
                else if (appCode === 'xiyin')
                    return null;
                return null;
            },

            getShareSlogan() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    return '发现世界之美、追踪全球美景';
                else if (appCode === 'adjiang')
                    return '你的星光、触手可及';
                else if (appCode === 'worldscene')
                    return '一屏一世界，一步一美景';
                else if (appCode === '西音')
                    return '看见缤纷的世界';
                else return "";
            },

            getShareDownloadPath() {
                const appCode = this.appCode;
                if (appCode === 'huocool')
                    return `${env.BACKEND_BASE_URL()}/d/app`
                else
                    return `${env.BACKEND_BASE_URL()}/d/app/${appCode}`
            },


            /**
             * init popupingEntity 根据访问的模式有不同的加载行为
             * v1 分开处理
             *   1. popup popupingEntity model，这种方式，popupingEntity 已经"提前由" Channel 的 page 给加载好了，并放入了 $store.state.popupingEntity 中了，
             *      因此这里就无需单独查询数据库了
             *   2. single page popupingEntity model，这种方式，又分为两种行为
             *      2.1 通过在浏览器中直接输入 /e/:shortcode 的方式进行访问，那么这个时候需要从数据库中加载 popupingEntity
             *      2.2 手机端，是从 Channel list page 通过路由 /e/:shortcode 进入的，同样是 single popupingEntity page 模式，这个时候，就不需要去
             *          数据库中加载 popupingEntity 了。TODO，这种情况该如何判断呢？有种好的办法，监听 route from 和 to 进行判断。
             * v2 统一处理，将两种访问模型统一进行处理。先查询 $store.state.popupingEntity，如果为 null 则异步加载，否则则直接渲染。TODO:-impl
             *
             * Cache Hit
             * 大部分的访问情况都是 List -> Entity，当点击 List page 中的某个 Entity 用于展示的时候（调用 List.showEntity），是直接从
             * List#entities 中获取的，然后将其 cache。然后通过路由变化进入 Entity page 并调用 initEntity，initEntity 直接从 Cache
             * 中获得 Entity。因此整个过程不会产生任何的远程调用。
             *
             */
            initEntity(){
                var mode = this.$store.getters.getShowEntityMode();  // default to single page mode. 所以，在需要 popup entity 显示的地方设置即可。
                console.log(this.$store);
                console.log('init entity, show entity mode', mode, 'the current route instance:', this.$route.name);

                // 这种方式通常是从 List page 中进入，并且当前要显示的 entity 已经由 List 存入了 cached popupingEntity 中了。
                if(mode == ShowEntityMode.PopupPageMode){
                    console.log('router channel');
                    this.entity = this.$store.state.currentEntity;
                    this.rendering = true;  // 开始渲染 Entity 组件。popup entity mode 下，之前的 entity 由 list 组件销毁。
                    saveViewHis(this.entity.shortcode);
                    Styles.disableBodyScroll();
                }

                // Single Page model，用户通过 e/:shortcode 连接直接进入
                else if(mode == ShowEntityMode.SinglePageMode){
                    this.isSinglePage = true;
                    var shortcode = this.$route.params.shortcode;
                    console.log('Entity, shortcode get parsed as', shortcode);
                    var entity = this.$store.getters.getCacheEntity(shortcode);
                    if(entity == null){
                        getEntity(shortcode).then((e)=>{
                            console.log('single entity mode, fetched entity', e, 'by shortcode', shortcode);
                            this.$store.commit('cacheEntity', e);
                            this.$store.commit('setCurrentEntity', e); // cache as current.
                            this.setTitle(e);
                            this.entity = e;
                            this.rendering = true;  // 开始渲染 Entity 组件
                            saveViewHis(this.entity.shortcode);
                            setTimeout(()=>{ // 必须等待 entity page 渲染成功后，才能获取到 list 组件
                                // 滚动到顶部，解决在 SinglePage 下，点击推荐 entity 后，仍然停留在推荐位置的问题。
                                // @deprecated by Router scroll-behavior
                                // window.scrollTo(0,0); // 必须在渲染后滚动，否则无效
                                // @since v2.3.0 为了避免用户通过微信分享蹭流量！
                                // this.$refs.list.initData(); // 加载 recommends
                            },300);
                        }).catch((err) => {
                            console.log(err);
                        });
                    }else{
                        console.log('Entity, the cache has been hit, loaded the entity', entity.shortcode);
                        this.$nextTick(()=>{ // 必须给足够时间给 Entity 去销毁。
                            this.entity = entity;
                            this.$store.commit('setCurrentEntity', entity); // cache as current.
                            this.setTitle(entity);
                            this.rendering = true;
                            saveViewHis(this.entity.shortcode);
                            setTimeout(()=>{ // 必须等待 entity page 渲染成功后，才能获取到 list 组件
                                // @deprecated by Router scroll-behavior
                                // window.scrollTo(0,0); // 滚动到顶部，必须渲染后滚动，否则无效
                                this.$refs.list.initData(); // 加载 recommends
                            },300);
                        })
                    }
                }
                this.pushSeos();
            },

            setTitle(entity){
                let location = entity.location === null ? '' : ` - ${entity.location}`;
                let caption = entity.caption === null ? '' : ` - ${entity.caption.substring(0,20)}`;
                document.title = `${this.getShareAppName()} ${location}${caption}`;
            },

            // 注意，自己需要被排除，否则页面后台会报错，无法 $route 到自己。
            async getRecommends(){
                try {
                    let recommends = await getSample(this.entity.profile_code, this.entity.shortcode);
                    this.noSignalVisible = false;
                    return recommends
                } catch (error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if ( error instanceof TimeoutError || error instanceof NetworkError ) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        let err = new NetworkError('no signal main page error, has been handled by channel');
                        err.handled = true;  // 通知 List page 我已经处理了，下一级就不要再处理了。
                        throw err;
                    }
                    throw error; // 必须抛出这个异常，否则 List 的 nextPage 调用该句柄的时候会认为是正常返回导致异常
                }
            },

            // mescroll 的回调方法，the handler for no signal retry usage.
            reloadPage(){
                this.rendering = false;
                GlobalLoading.start();
                setTimeout(()=>{
                    this.rendering = true
                    console.log('entity, the page start to reloading');
                    console.log('entity, start to retry the next page handler');
                    setTimeout(()=>{
                        this.$refs.list.initData();
                        GlobalLoading.stop();
                    }, 300)  // give enough time for the page to reloaded. 否则 list 得不到报错。
                }, 100) // gives enough time to clean the page.
            },

            // mescroll 的回调方法，这个方法只是用来处理网络异常的情况的
            pullDownCallbackHandler(){
                console.log('entity, pull down callback handler called...');
                if (this.noSignalVisible === true) { // 如果出现了网络异常
                    this.reloadPage()
                }
            },

            updateInfoboardHeight(height){
                this.infoboardHeight=Number(height);
            },

            updateInfoboardWidth(width){
                this.infoboardWidth=Number(width);
            },

            // 调用父组件即 popup popupingEntity 处理 spacing 相关逻辑。
            handleSpacing(spacing) {
                // 如果是直接访问 Entity，那么父组件不再是 popup enitty，因此就没有 spacingCtr 这个方法
                if(this.$parent.spacingCtr !=null )
                    this.$parent.spacingCtr(spacing);
            },

            pushSeos(){
                console.log('channel push seo, process.env.NODE_ENV:', process.env.NODE_ENV);
                if (process.env.NODE_ENV === 'production' && !isHybridAgent()){
                    pushBaiduSeo();
                    // pushSoSeo();
                }
            },
        }
    }
</script>

<style scoped>
    /* 使得 Carsousel 和 inforboard 的布局在一个 flex 容器中 */
    .entity-wrapper {
        display:flex;
        flex-wrap:wrap;
        justify-content: center;
        align-items: center;
        /*overflow: scroll;*/ /* 这里不需要再 scroll 了，直接使用 body scroll 即可 */
        font-size: 14px
    }

    /* 自定义 divider 的 margin */
    .el-divider--horizontal{
        height: 1px;
        margin-top: 40px;
        margin-bottom: 40px;
    }

    .el-divider__text{
        padding: 0 !important;
        background-color: rgb(250, 250, 250) !important;
    }

    /* 手机端 margin-top 需要是 20px，现在认为 540 以下的都是手机端 */
    @media (max-width: 540px){
        .el-divider--horizontal{
            margin-top: 20px;
        }
    }

    /deep/ .mescroll {
        overflow: initial;
    }

    /deep/ .mescroll-downwarp {
        top: 40px !important;
    }

    .download-app-pc-align {
        margin: 60px 0 10px 0
    }

</style>



// WEBPACK FOOTER //
// src/components/entity/Entity.vue